<template>
  <panel>
    <loader :loading="loading"/>
    <canvas :id="identifier" width="400" height="200"></canvas>
  </panel>
</template>

<script>

  import Chart from 'chart.js'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'

  export default {
    props: {
      identifier: {
        type: String,
        required: true
      },
      data: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    mounted () {
      var element = document.getElementById(this.identifier)
      var chart = new Chart(element, {
        type: 'pie',
        data: {
          labels: this.labels(),
          datasets: this.datasets()
        },
        options: {
          responsive: true,
          animation: {
            animateScale: true
          }
        }
      })
      chart.chart
    },
    methods: {
      labels () {
        return this.data.labels
      },
      datasets () {
        let datasets = []
        let colors = ['#52B4E7', '#A3EB57', '#FCCA5E', '#86CCFF', '#E481C9', '#EFDE43', '#8DB8C6', '#C9C8A6', '#39BACD', '#D0EB43', '#A093FC']

        const values = []

        for (const line of this.data.lines) {
          for (const value of line.values) {
            values.push(value)
          }
        }

        datasets.push({
          borderColor: this.data.colors || colors,
          backgroundColor: this.data.colors || colors,
          data: values
        })

        return datasets
      }
    },
    components: {
      Panel,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// PieChart.vue?204984a3